export default {
  SCHEDULE_CONTENT: 'SCHEDULE_CONTENT',
  SET_DEFAULT_CONTENT: 'SET_DEFAULT_CONTENT',
  SELECT_CONTENT_TYPE_COLOR: 'SELECT_CONTENT_TYPE_COLOR',
  SELECT_CONTENT_TYPE_THEME: 'SELECT_CONTENT_TYPE_THEME',
}



// WEBPACK FOOTER //
// ./src/constants/create-nav.js